import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  GetMultiPartnerHealthRequest,
  GetPartnerHealthRequest,
  ListPartnerHealthRequest,
  SetPartnerHealthRequest,
} from '@vendasta/partner';
import { PartnerHealthsApiService } from '@vendasta/partner';
import { PartnerHealthsServiceInterface } from './interfaces';
import { PartnerHealthState, PartnerHealthSubState } from '@vendasta/partner';
import {
  GetMultiPartnerHealthResponseInterface,
  ListPartnerHealthResponseInterface,
  PartnerHealthInterface,
} from '@vendasta/partner';

@Injectable({ providedIn: 'root' })
export class PartnerHealthsService implements PartnerHealthsServiceInterface {
  constructor(private api: PartnerHealthsApiService) {}

  set(
    partnerId: string,
    state: PartnerHealthState,
    subState: PartnerHealthSubState,
    reason: string,
    inRetention: boolean,
  ): Observable<boolean> {
    const req = new SetPartnerHealthRequest({
      partnerId: partnerId,
      state: state,
      subState: subState,
      reason: reason,
      inRetention: inRetention,
    });
    return this.api.set(req).pipe(map((res) => res.status === 200));
  }

  get(partnerId: string): Observable<PartnerHealthInterface> {
    const req = new GetPartnerHealthRequest({ partnerId: partnerId });
    return this.api.get(req).pipe(map((res) => res.health || {}));
  }

  list(partnerId: string, pageSize: number, cursor: string): Observable<ListPartnerHealthResponseInterface> {
    const req = new ListPartnerHealthRequest({ partnerId: partnerId, pageSize: pageSize, cursor: cursor });
    return this.api.list(req);
  }

  getMulti(partnerIds: string[]): Observable<GetMultiPartnerHealthResponseInterface> {
    const req = new GetMultiPartnerHealthRequest({ partnerIds: partnerIds });
    return this.api.getMulti(req);
  }
}
